<div class="modal-header">
    <h5 class="modal-title" style="padding-left: 1.5rem;">
        {{
            (form.get('type')?.value === 'refund'
            ? 'company.transaction.edit-transaction-refund'
            : 'company.transaction.edit-transaction') | translate
        }}
    </h5>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" style="padding: 2.5rem;">
  <form [formGroup]="form" novalidate>
    <div class="form-group">
      <label>{{ 'company.transaction.filters.status' | translate }}</label>
      <select class="form-control" formControlName="type">
        <option *ngFor="let t of types" [value]="t.value">{{ t.i18n | translate }}</option>
      </select>
    </div>

    <div class="form-group">
      <label>{{ 'company.transaction.order-code' | translate }}</label>
      <input type="text" class="form-control" formControlName="order" maxlength="50" />
    </div>


    <div class="mt-3">
        <label class="d-block mb-2">
            {{
                (form.get('type')?.value === 'refund'
                ? 'company.transaction.filters.amount-refund'
                : 'company.transaction.filters.amount') | translate
            }} (€)
        </label>

        <div formArrayName="breakdown">
            <div class="mb-3" *ngFor="let row of breakdown.controls; let i = index" [formGroupName]="i">
                <div class="mb-2">
                  <strong class="d-block">{{ row.get('label')?.value }}</strong>

                  <div *ngIf="row.get('passenger')?.value" class="text-muted small">
                      <strong>{{ 'flight.form-flight.passenger' | translate }}:</strong>
                      {{ row.get('passenger')?.value }}
                  </div>
                </div>

                <div>
                  <input
                      type="text"
                      class="form-control"
                      formControlName="amount"
                      inputmode="decimal"
                      autocomplete="off"
                      (blur)="normalizeEmpty(i)"
                  />
                  <small *ngIf="row.get('amount')?.touched && row.get('amount')?.invalid" class="text-danger">
                      {{ 'company.transaction.errors.invalid-import' | translate }}
                  </small>
                </div>
            </div>
        </div>

      <div class="text-right mt-2">
        <strong>{{ 'csv.total' | translate }}:</strong>
        {{ form.get('amount')?.value }} €
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="cancel()">{{ 'common.cancel' | translate }}</button>
  <button type="button" class="btn btn-primary" style="color:white!important" (click)="save()">
    {{ 'common.save' | translate }}
  </button>
</div>
